export const DISCLAIMER_VERSION = 'v1.0';

export const GLOBAL_DISCLAIMER_TEXT =
  '本报告基于本次采集数据和AI算法生成，仅用于营养健康管理、生活方式改善和复测趋势参考，不作为疾病诊断、治疗、用药或医学检查依据。如有身体不适、既往疾病、体检异常或正在用药，请咨询医生或前往正规医疗机构检查。';

export const VALUE_NOTICE_TEXT =
  '本页数值为基于本次采集数据生成的算法趋势分值，不代表血液浓度、营养素含量或医学检验结果。';

export const SHARE_DISCLAIMER_TEXT =
  '营养状态趋势评估仅供健康管理参考，不作为临床诊断依据。';

export const AI_REJECTION_TEXT =
  '本AI无法判断疾病或提供用药建议，请咨询医生或正规医疗机构。';

export const AI_SENSITIVE_KEYWORDS = [
  '疾病',
  '诊断',
  '治疗',
  '糖尿病',
  '高血压',
  '癌症',
  '肿瘤',
  '药物',
  '处方',
  '药',
  '肝功能',
  '肝有问题',
  '肾功能',
  '肾有问题',
  '贫血',
  '缺乏症'
];
